// extracted by css-extract-rspack-plugin
export default {"cls1":"CurrentPaperRow-cls1_brZ","cls2":"CurrentPaperRow-cls2_K-R CurrentPaperRow-cls1_brZ"};